// extracted by mini-css-extract-plugin
export default {"modal":"ImageModal_modal__ZxbXq","headingText":"ImageModal_headingText__R5l+3"};